export function initVideoCard() {
  function replaceWithPlayer(imgEl) {
    console.debug("I will replace with a video player:", imgEl);
    var url = imgEl.closest('[data-video-url]').getAttribute('data-video-url');
    var playerIframe = document.createElement('iframe');
    playerIframe.setAttribute('src', url + '?embed');
    playerIframe.setAttribute('scrolling', 'no');
    playerIframe.setAttribute('allowfullscreen', 'allowfullscreen');
    playerIframe.setAttribute('width', imgEl.getBoundingClientRect().width);
    playerIframe.setAttribute('height', imgEl.getBoundingClientRect().height);
    playerIframe.setAttribute('style', 'border: 0');
    imgEl.closest('.card__image a').replaceWith(playerIframe);
  }
  document.addEventListener('lazybeforeunveil', function (ev) {
    // NB: closest doesn't work on IE
    if (ev.target.closest('[data-video-url]') !== null) {
      replaceWithPlayer(ev.target);
    }
  });
}
